import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import CustomButton from './CustomButton'
import { isInternalUser } from './helpers/constants'
import { isCustomUserPermissions } from './helpers/helperUsers'
import { CustomButtonToggle } from "./DropdownComponents";
import { ReactComponent as Check } from '../../../assets/check-icon.svg';

import './FilterMenu.sass';

const CheckIcon = () => {
    return (
        <Check style={{ width: '16px', height: '16px', flexShrink: 0 }} />
    )
}

// TODO: needs to develop universal filter menu for events
const FilterMenu = (props) => {
    const {
        userRole,
        user,
        filters = {},
        videostatuses,
        groups,
        selectAllFilters,
        fillFilters,
        fillVideostatuseFilters,
        fillGroups,
        selectAllGroups,
        onMoreGroupsClick,
        twoColumns,
        columns,
        columnsLabels,
        toggleColumn,
        DV7access
    } = props;

    const userPermissions = user.permissions;
    const { t } = useTranslation();

    const canEventFeedbackView = !['custom_user', 'custom_partner'].includes(userRole)
        || (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add'))
        || (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit'))

    let countSelectedFilters = canEventFeedbackView ? 0 : 1
    let showFilterActive = false
    for (let [filter, value] of Object.entries(filters)) {
        value && countSelectedFilters++
        if (!['pending', 'feedback'].includes(filter) && !value) {
            showFilterActive = true
        }
    }

    const countSelectedGroups = _.reduce(groups, (sum, value, key) => { if (value.selected) { return sum + 1 } return sum }, 0)
    const countVisibleGroups = _.reduce(groups, (sum, value, key) => { if (value.visible) { return sum + 1 } return sum }, 0)

    return (
        <Dropdown
            id="type-filter-btn"
            align='end'
            className="event-filters"
            drop
        >
            <Dropdown.Toggle
                as={CustomButtonToggle}
                variant='primary-outline'
                wrapperClassName="no-caret event-filter-button"
            >
                {t('eventsPage.FilterMenu.filter')}
            </Dropdown.Toggle>
            <Dropdown.Menu
                className="event-filter-menu"
            >
                {/* ToDo: Temporary hidden. Enable this part when Asset type and Device type filter's support is implemented on BE */}
                {/*<h5 className="category-title">{t('eventsPage.FilterMenu.allFilters').toUpperCase()}</h5>*/}
                {/*<h6 className="category-subtitle">{t('eventsPage.FilterMenu.assetType')}</h6>*/}
                {/*<ul className={classNames('filters-list centered-value', {'two-columns': twoColumns})}>*/}
                {/*    <li>*/}
                {/*        <button className='filter-button' onClick={() => {}}>*/}
                {/*            <span className="button-label">{t('eventsPage.FilterMenu.vehicle')}</span>*/}
                {/*            <CheckIcon/>*/}
                {/*        </button>*/}
                {/*    </li>*/}
                {/*</ul>*/}
                {/*<h6 className="category-subtitle">{t('eventsPage.FilterMenu.deviceType')}</h6>*/}
                {/*<ul className={classNames('filters-list centered-value', {'two-columns': twoColumns})}>*/}
                {/*    <li>*/}
                {/*        <button className='filter-button' onClick={() => {}}>*/}
                {/*            <span className="button-label">DV6</span>*/}
                {/*            <CheckIcon/>*/}
                {/*        </button>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <button className='filter-button' onClick={() => {}}>*/}
                {/*            <span className="button-label">DV7</span>*/}
                {/*            <CheckIcon/>*/}
                {/*        </button>*/}
                {/*    </li>*/}
                {/*    <li>*/}
                {/*        <button className='filter-button' onClick={() => {}}>*/}
                {/*            <span className="button-label">{t('eventsPage.FilterMenu.miniRouter')}</span>*/}
                {/*            <CheckIcon/>*/}
                {/*        </button>*/}
                {/*    </li>*/}
                {/*</ul>*/}
                {(columns && columnsLabels) ? (
                    <>
                        <h5 className="category-title">{t('eventsPage.FilterMenu.columns').toUpperCase()}</h5>
                        <ul className={classNames('filters-list columns-filter', { 'two-columns': twoColumns })}>
                            {
                                Object.entries(columns).map(([key, isSelected]) => (
                                    <li key={key}>
                                        <button className='filter-button' onClick={() => toggleColumn({ key, isSelected })}>
                                            <span className="button-label">{columnsLabels[key] || key}</span>
                                            {isSelected && <CheckIcon />}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                    </>
                ) : (
                    ''
                )}
                {!_.isEmpty(filters) ? (
                    <>
                        <h5 className="category-title">{t('eventsPage.FilterMenu.titleEvents').toUpperCase()}</h5>
                        {selectAllFilters ? (
                            <CustomButton
                                variant="link"
                                onClick={selectAllFilters}
                            >
                                {`${countSelectedFilters === Object.keys(filters).length ? t('eventsPage.FilterMenu.unselect') : t('eventsPage.FilterMenu.select')} ${t('eventsPage.FilterMenu.all')}`}
                            </CustomButton>
                        ) : (
                            ''
                        )}
                        <ul className={classNames('filters-list', { 'two-columns': twoColumns })}>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('critical_gsensor')}>
                                    <span className="button-label">{t('constants.eventNames.High_G-Force')}</span>
                                    {filters.critical_gsensor && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('speed')}>
                                    <span className="button-label">{t('constants.eventNames.Max_Speed')}</span>
                                    {filters.speed && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('driver')}>
                                    <span className="button-label">{t('constants.eventNames.Driver')}</span>
                                    {filters.driver && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('custom')}>
                                    <span className="button-label">{t('constants.eventNames.Custom')}</span>
                                    {filters.custom && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('harshaccel')}>
                                    <span className="button-label">{t('constants.eventNames.Harsh_Acceleration')}</span>
                                    {filters.harshaccel && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('harshbraking')}>
                                    <span className="button-label">{t('constants.eventNames.Harsh_Braking')}</span>
                                    {filters.harshbraking && <CheckIcon />}
                                </button>
                            </li>
                            {!isInternalUser(userRole) &&
                                <li>
                                    <button className='filter-button' onClick={() => fillFilters('pending')}>
                                        <span className="button-label">{t('constants.eventNames.Pending')}</span>
                                        {filters.pending && <CheckIcon />}
                                    </button>
                                </li>
                            }
                            {canEventFeedbackView &&
                                <li>
                                    <button className='filter-button' onClick={() => fillFilters('feedback')}>
                                        <span className="button-label">{t('constants.eventNames.Feedback')}</span>
                                        {filters.feedback && <CheckIcon />}
                                    </button>
                                </li>
                            }
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('reviewed')}>
                                    <span className="button-label">{t('constants.eventNames.Reviewed')}</span>
                                    {filters.reviewed && <CheckIcon />}
                                </button>
                            </li>
                            {DV7access && (<>
                                <li>
                                    <button className='filter-button' onClick={() => fillFilters('gsensor_wakeup')}>
                                        <span className="button-label">{t('constants.eventNames.G-Sensor_Wake-Up')}</span>
                                        {filters.gsensor_wakeup && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button' onClick={() => fillFilters('backup_warning')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Dangerous_Backing-Up_Alerts')}</span>
                                        {filters.backup_warning && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('blind_spot_warning_standard')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Standard_Blind_Spot_Detection_Warning')}</span>
                                        {filters.blind_spot_warning_standard && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('blind_spot_warning_urban')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Urban_Blind_Spot_Detection_Warning')}</span>
                                        {filters.blind_spot_warning_urban && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('low_speeding')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Blind_Spot_Detection_Warning_Low')}</span>
                                        {filters.low_speeding && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('moderate_speeding')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Blind_Spot_Detection_Warning_Moderate')}</span>
                                        {filters.moderate_speeding && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('high_speeding')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Blind_Spot_Detection_Warning_High')}</span>
                                        {filters.high_speeding && <CheckIcon />}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                        onClick={() => fillFilters('severe_speeding')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Blind_Spot_Detection_Warning_Severe')}</span>
                                        {filters.severe_speeding && <CheckIcon />}
                                    </button>
                                </li>
                            </>)}
                        </ul>
                        {isInternalUser(userRole) && videostatuses && (
                            <>
                                <h6 className="category-subtitle">{t('eventsPage.FilterMenu.titleVideoStatus')}</h6>
                                <ul className={classNames('filters-list', { 'two-columns': twoColumns })}>
                                    {Object.keys(videostatuses).map((item) => {
                                        return (
                                            <li key={item}>
                                                <button className='filter-button' onClick={() => fillVideostatuseFilters(item)} key={item}>
                                                    <span className="button-label">{t(`eventsPage.videostatuses.${item}`, item)}</span>
                                                    {videostatuses[item] && <CheckIcon />}
                                                </button>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                            </>
                        )}
                        <h6 className="category-subtitle">{t('eventsPage.FilterMenu.titleDMS')}</h6>
                        <ul className={classNames('filters-list', { 'two-columns': twoColumns })}>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('distraction')}>
                                    <span className="button-label">{t('constants.eventNames.Distraction')}</span>
                                    {filters.distraction && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('drowsiness')}>
                                    <span className="button-label">{t('constants.eventNames.Drowsiness/Head_Down')}</span>
                                    {filters.drowsiness && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('phone_use')}>
                                    <span className="button-label">{t('constants.eventNames.Phone_Use/Hand_to_Head')}</span>
                                    {filters.phone_use && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('yawning')}>
                                    <span className="button-label">{t('constants.eventNames.Yawning')}</span>
                                    {filters.yawning && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('seatbelt')}>
                                    <span className="button-label">{t('constants.eventNames.Seatbelt')}</span>
                                    {filters.seatbelt && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('smoking')}>
                                    <span className="button-label">{t('constants.eventNames.Smoking')}</span>
                                    {filters.smoking && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('camerablock')}>
                                    <span className="button-label">{t('constants.eventNames.Potential_Ch2_Obstruction')}</span>
                                    {filters.camerablock && <CheckIcon />}
                                </button>
                            </li>
                        </ul>
                        <h6 className="category-subtitle">{t('eventsPage.FilterMenu.titleADAS')}</h6>
                        <ul className={classNames('filters-list', { 'two-columns': twoColumns })}>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('adas_ldw')}>
                                    <span className="button-label">{t('constants.eventNames.Lane_Departure')}</span>
                                    {filters.adas_ldw && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('adas_fcw')}>
                                    <span className="button-label">{t('constants.eventNames.Forward_Collision')}</span>
                                    {filters.adas_fcw && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('adas_hw')}>
                                    <span className="button-label">{t('constants.eventNames.Headway_Warning')}</span>
                                    {filters.adas_hw && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('adas_pcw')}>
                                    <span className="button-label">{t('constants.eventNames.Pedestrian_Warning')}</span>
                                    {filters.adas_pcw && <CheckIcon />}
                                </button>
                            </li>
                            <li>
                                <button className='filter-button' onClick={() => fillFilters('tailgating')}>
                                    <span className="button-label">{t('constants.eventNames.Tailgating')}</span>
                                    {filters.tailgating && <CheckIcon />}
                                </button>
                            </li>
                            {DV7access && (<>
                                <li>
                                    <button className='filter-button'
                                            onClick={() => fillFilters('front_vehicle_start')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Front_Vehicle_Start_Alert')}</span>
                                        {filters.front_vehicle_start && <CheckIcon/>}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                            onClick={() => fillFilters('TrafficLightViolation_SAW')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Signal_Approach')}</span>
                                        {filters.TrafficLightViolation_SAW && <CheckIcon/>}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                            onClick={() => fillFilters('TrafficLightViolation_SVW')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Signal_Violation')}</span>
                                        {filters.TrafficLightViolation_SVW && <CheckIcon/>}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                            onClick={() => fillFilters('StopSignViolation_RSW')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Rolling_Stop')}</span>
                                        {filters.StopSignViolation_RSW && <CheckIcon/>}
                                    </button>
                                </li>
                                <li>
                                    <button className='filter-button'
                                            onClick={() => fillFilters('StopSignViolation_BSW')}>
                                        <span
                                            className="button-label">{t('constants.eventNames.Bypass_Stop')}</span>
                                        {filters.StopSignViolation_BSW && <CheckIcon/>}
                                    </button>
                                </li>
                            </>)}
                        </ul>
                        <h5 className="category-title">{t('eventsPage.FilterMenu.groupsTitle').toUpperCase()}</h5>
                        {selectAllGroups ? (
                            <CustomButton
                                variant="link"
                                onClick={selectAllGroups}
                            >
                            {`${countSelectedGroups === groups.length ? t('eventsPage.FilterMenu.unselect') : t('eventsPage.FilterMenu.select')} ${t('eventsPage.FilterMenu.all')}`}
                            </CustomButton>
                        ) : (
                            ''
                        )}
                        {fillGroups ? (
                            <ul className={classNames('filters-list', {'two-columns': twoColumns})}>
                                {groups.map(({group_name, id, selected, visible}) => (
                                    <li key={id} className={`${!visible && 'hide'}`}>
                                        <button className='filter-button' onClick={() => fillGroups(id)} title={group_name}>
                                            <span
                                                className="button-label">{group_name || t('eventsPage.FilterMenu.unnamed')}</span>
                                            {selected && <CheckIcon />}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            ''
                        )}
                        {onMoreGroupsClick && countVisibleGroups < groups.length ? (
                            <CustomButton variant="link"
                                onClick={onMoreGroupsClick}>{t('eventsPage.FilterMenu.btnMore')}</CustomButton>
                        ) : (
                            ''
                        )}
                    </>
                ) : (
                    ''
                )}
            </Dropdown.Menu>
        </Dropdown>
    )
}

FilterMenu.propTypes = {
    userRole: PropTypes.string.isRequired,
    filters: PropTypes.objectOf(PropTypes.bool),
    videostatuses: PropTypes.objectOf(PropTypes.bool),
    groups: PropTypes.arrayOf(PropTypes.object),
    selectAllFilters: PropTypes.func,
    fillFilters: PropTypes.func,
    fillVideostatuseFilters: PropTypes.func,
    fillGroups: PropTypes.func,
    selectAllGroups: PropTypes.func,
    onMoreGroupsClick: PropTypes.func,
}

export default FilterMenu;
